export type RankingRule = {
	name: string;
	id?:string;
	description: string;
	sorting: Array<{
		collationId: string;
		params: any[];
		period?: any;
		weight: number;
	}>;
	tenant?: string | null;
	transformations: Transformation[];
	groupSorting?: any;
};
type Transformation = {
	collationId: string;
	params: Array<{
		name: string;
		value: {
			stringValues: string[];
		};
	}>;
};
export const exampleRule: RankingRule = {
	name: 'New ranking rule',
	description: '',
	tenant: null,
	sorting: [],
	groupSorting: null,
	transformations: []
};

// export type RankingRule = {
// 	segmentedRankingUsages: any[];
// 	groupSorting: any | null;
// 	sorting: any[];
// 	transformations: Transformation[];
// 	tenant: string;
// 	usedCount: number | null;
// 	name: string;
// 	description: string;
// 	id: string;
// 	lastUpdatedUtc: string;
// };

// type Transformation = {
// 	collationId: string;
// 	params: Param[];
// };
//
// type Param = {
// 	name: string;
// 	value: {
// 		stringValues: string[];
// 	};
// };